var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrinkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-wrinkles"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-162.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Wrinkles",
    transform: "translate(164.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-wrinkles"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-wrinkles"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.6953,27 L24.3043,27 C22.5173,28.256 20.3453,29 18.0003,29 C15.6543,29 13.4823,28.256 11.6953,27 Z M18.0003,7 C21.7333,7 25.0843,8.924 27.0783,11.836 C25.7923,11.602 24.9243,11.139 23.9743,10.622 C22.5803,9.862 20.9993,9 17.9913,9 C14.9863,9 13.4073,9.862 12.0133,10.622 C11.0693,11.137 10.2053,11.598 8.9303,11.833 C10.9253,8.918 14.2713,7 18.0003,7 Z M24.4403,14.605 C22.8603,13.816 21.2273,13 17.9913,13 C14.7573,13 13.1253,13.816 11.5473,14.605 C10.3413,15.208 9.1823,15.778 7.2063,15.946 C7.3373,15.263 7.5303,14.603 7.7813,13.971 C10.2773,13.833 11.7073,13.067 12.9703,12.378 C14.3263,11.639 15.4973,11 17.9913,11 C20.4893,11 21.6613,11.639 23.0173,12.378 C24.2853,13.069 25.7183,13.836 28.2243,13.972 C28.4763,14.604 28.6703,15.265 28.7993,15.948 C26.8113,15.781 25.6493,15.21 24.4403,14.605 Z M27.8113,22.547 C25.3973,21.786 22.9023,21 17.9883,21 C13.0783,21 10.5843,21.787 8.1733,22.547 C8.1223,22.563 8.0693,22.578 8.0183,22.594 C7.8873,22.311 7.7703,22.021 7.6633,21.726 C8.9173,21.4 9.9183,20.971 10.8853,20.55 C12.7173,19.753 14.4493,19 17.9903,19 C21.5343,19 23.2663,19.753 25.1003,20.55 C26.0723,20.973 27.0763,21.402 28.3363,21.728 C28.2283,22.024 28.1113,22.314 27.9793,22.598 C27.9243,22.581 27.8673,22.564 27.8113,22.547 Z M9.5213,25 C9.3533,24.798 9.2013,24.583 9.0483,24.369 C11.3213,23.654 13.5623,23 17.9883,23 C22.4253,23 24.6693,23.656 26.9493,24.373 C26.7973,24.585 26.6443,24.799 26.4783,25 L9.5213,25 Z M29.0003,18 C29.0003,18.612 28.9373,19.208 28.8413,19.792 C27.7293,19.506 26.8303,19.122 25.8983,18.716 C23.9573,17.873 21.9503,17 17.9903,17 C14.0333,17 12.0273,17.873 10.0883,18.716 C9.1593,19.12 8.2633,19.503 7.1593,19.79 C7.0643,19.214 7.0013,18.627 7.0003,18.024 L7.0033,17.967 C9.5823,17.815 11.0373,17.097 12.4413,16.395 C13.8753,15.677 15.2293,15 17.9913,15 C20.7563,15 22.1113,15.677 23.5463,16.395 C24.9523,17.098 26.4113,17.817 28.9983,17.967 L29.0003,18 Z M30.9463,16.916 C30.3923,10.234 24.7063,5 18.0003,5 C11.2943,5 5.6073,10.234 5.0513,16.948 L5.0013,17.949 L5.0003,18 C5.0003,25.168 10.8323,31 18.0003,31 C25.1683,31 31.0003,25.168 30.9993,17.949 L30.9463,16.916 Z",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrinkles);
export default __webpack_public_path__ + "static/media/Wrinkles.bcd6c58158a5914003a38c3a72ce55aa.svg";
export { ForwardRef as ReactComponent };